import React, { useMemo, useState } from "react";
import "./MyTravellers.css";
import images from "../../../Utils/importImages";
import { useDispatch, useSelector } from "react-redux";
import NoTravellers from "./NoTravellers";
import TravellersHeader from "./TravellersHeader";
import AddTravellerForm from "./TravellerForm";
import { setUserLoggedInData } from "../../../Redux/Slices/User_Slices/User-SLICE";
import toast from "react-hot-toast";
import TravellersRow from "./TravellersRow";
import Swal from "sweetalert2";
import TravellerForm from "./TravellerForm";

import {
  AddTraveller,
  RemoveTraveller,
  UpdateTraveller,
} from "../../../Redux/Apis/User-Apis";
import { getLocalStorageJSON } from "../../../Utils/localStorageFunc";
import { MAIN_URL } from "../../../Configs/Urls";

function MyTravellers() {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  let [travellerDetail, setTravellerDetail] = useState(
    userLoggedInData?.travellers
  );

  let [addTraveller, setAddTraveller] = useState(false);

  let onCancelAddTravel = () => {
    setAddTraveller(false);
  };

  let onSaveAddTravel = async (data) => {

    let dj = data;

    let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
    let res = await AddTraveller(
      dj,
      isUserLogin ? `${MAIN_URL}users/${userLoggedInData.id}/user-travellers` : `${MAIN_URL}admins/${userLoggedInData.id}/travellers`,
      token
    );

    console.log("here im");
    
    if (res.error == false) {
      let dd = [...travellerDetail];
      dd.push(res.data.traveller);
      setTravellerDetail(dd);

      let dm = {
        ...userLoggedInData,
        travellers: dd,
      };

      dispatch(setUserLoggedInData(dm));

      setAddTraveller(false);
    }
  };

  let onSaveEditTravel = async (data, id) => {

    let dj = data;

    console.log("data for sne dis L: " , data);
    
    let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
    let res = await UpdateTraveller(
      dj,
      isUserLogin ? `${MAIN_URL}users/${userLoggedInData.id}/user-travellers/${id}` : `${MAIN_URL}admins/${userLoggedInData.id}/travellers/${id}`,
      token
    );

    if (res.error == false) {
      let dd = [...travellerDetail];

      let indexOfElement = dd?.findIndex((item) => item.id == id);
      dd[indexOfElement] = res.data.traveller;

      setTravellerDetail(dd);

      let dm = {
        ...userLoggedInData,
        travellers: dd,
      };

      dispatch(setUserLoggedInData(dm));
    }
  };

  let onRemoveTraveller = async (id, callFunc) => {
    Swal.fire({
      title: "Do You Really Want To Remove This Traveller ?",
      showCancelButton: true,
      confirmButtonText: "Yes Remove",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
        let res = await RemoveTraveller(

          isUserLogin ? `${MAIN_URL}users/${userLoggedInData.id}/user-travellers/${id}` : `${MAIN_URL}admins/${userLoggedInData.id}/travellers/${id}`,
          token
        );

        if (res.error == false) {
          let dd = [...travellerDetail];

          let final = dd.filter((item) => item.id != id);
          setTravellerDetail(final);

          let dm = {
            ...userLoggedInData,
            travellers: final,
          };

          dispatch(setUserLoggedInData(dm));
          callFunc(false);
          toast.success("Traveller Removed Successfully", {
            style: {
              fontFamily: `var(--font-family-proxima_nova-semibold)`,
              borderRadius: "10px",
              background: "#333",
              color: "#fff",
            },

            duration: 4000,
          });
        }
      }
    });
  };

  let [searchTerm, setSearchTerm] = useState("");

  // Optimize filtering with useMemo to avoid unnecessary computations
  const filteredTravellers = useMemo(() => {
    return travellerDetail?.filter((item) =>
      `${item.first_name} ${item.last_name}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, travellerDetail]);

  return (
    <div className="my-travellers proxima_regular">
      <TravellersHeader
        setAddTraveller={setAddTraveller}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      {travellerDetail.length == 0 && !addTraveller ? (
        <NoTravellers />
      ) : (
        <>
          {addTraveller == true && (
            <TravellerForm
              onClickCancel={onCancelAddTravel}
              onClickSave={onSaveAddTravel}
              Data={{
                title: "",
                first_name: "",
                last_name: "",
                date_of_birth: "",
                email: "",
                phone_number: "",
                relationship: "",
                gender: null,
                pincode: "",
                address: "",
                state_id: null,
                country_id: null,
                passport_number: "",
                passport_expiry_date: "",
                passport_issue_date: "",
                passport_issuing_country_id: null,
                country: null,
                state: null,
              }}
            />
          )}
          {addTraveller == false && (
            <>
              {filteredTravellers?.map((item, id) => (
                <div key={id}>
                  <TravellersRow
                    key={id}
                    Data={item}
                    onClickRemove={onRemoveTraveller}
                    onClickSaveEditTravel={onSaveEditTravel}
                  />
                </div>
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
}

export default MyTravellers;
